import React, { useEffect } from 'react';
import { Form, Input, Select, Button, Spin } from 'antd';
import  { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cfdiUse from  '../../Catalogs/cfdiUse.json';
import License from '../../Actions/license';
const { getInvoiceData,saveInvoiceData,setInvoiceField } = License.actions;

function BillingData(props) {
	const [form] = Form.useForm();
	const { showSaveButton = true, stampPackageInvoice } = props;
	//this is the equivalent to didMount
    useEffect(() => {
		props.getInvoiceData();
  	}, []);

	useEffect(() => {
        form.setFieldsValue(props.invoiceInfo);
    }, [props.invoiceInfo]);

	const handleSubmit = values => {
		if(stampPackageInvoice) {
			stampPackageInvoice();
		} else {
			const invoiceData = {
				...props.invoiceInfo,
				...values
			}
			props.saveInvoiceData(invoiceData);
		}
			
	}

	const setInputData = (key, value) => {
        props.setInvoiceField({ [key]: value });
    }
	
		return (
			<Form form={form} onFinish={handleSubmit} style={{justifyContent: 'flex-start', maxWidth: '500px', margin: '0 auto'}} >
					<Form.Item
						label="RFC:"
						labelCol={{ span: 24 }}						
						name="taxId"
						style={{marginBottom:0}} 
						rules={[
							{ required: true, message: "¡Favor de introducir su RFC!" }
						 ]}
						>	
						<Input						
							onChange={(e)=>{setInputData('taxId', e.target.value)}}
						/>
					</Form.Item>
					<Form.Item
						label="Nombre o Razón Social:"
						labelCol={{ span: 24 }}						
						name="fiscalName"
						style={{marginBottom:0}} 
						rules={[
							{ required: true, message: "¡Favor de introducir su razón social!" }
						 ]}
						>	
						<Input
							onChange={(e)=>{setInputData('fiscalName', e.target.value)}}			
						/>
					</Form.Item>
					<Form.Item 
                              label="Uso de CFDI" 
                              labelCol={{ span: 24 }}
							  name="receiptUsage"
							  style={{marginBottom:0}} 
							  rules={[
								{ required: true, message: "¡Favor de seleccionar el uso de CFDI" }
							 ]}
							  >
                              <Select
                                  onChange={(value)=>{setInputData('receiptUsage', value)}}
                                  style={{ width: '100%' }}
                                  optionLabelProp="label"				
                              >  
							  	 {
                                        cfdiUse.map((item, index)  => {
                                            return <Select.Option key={index} value={item.clave}>{item.clave} - {item.label}</Select.Option>
                                        })
                                }                           
                              </Select>
                    </Form.Item>
					<Form.Item
						label="Copia al correo electrónico:"
						labelCol={{ span: 24 }}						
						name="emailAddresses"
						style={{marginBottom:0}} 
						rules={[
							{ type: "email"}							
						 ]}
						>	
						<Input
							onChange={(e)=>{setInputData('emailAddresses', e.target.value)}}	
						/>
					</Form.Item>
					<div className="center-button-login" style={{marginTop: '40px'}}>
						<Button type="primary" key="back" htmlType="submit"  disabled={
						form.getFieldsError().filter(({ errors }) => errors.length).length > 0
						}>
							{stampPackageInvoice ?  'Generar Factura' : 'Guardar'}						
						</Button>
						
					</div>
					{
						props.isLoading &&
						<div className="loading-container">
							<Spin size="large" tip="Cargando" />
						</div>
					}					
				</Form>
        )
    }

const mapStateToProps = state => {
	return {		
		isLoading: state._genericComponents.loading.isCurrentlyLoading,
		invoiceInfo: state.license.invoiceData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatch,
		...bindActionCreators({getInvoiceData,saveInvoiceData,setInvoiceField},dispatch)
	}
}
	
export default connect(mapStateToProps, mapDispatchToProps)(BillingData);
